/* eslint-disable no-restricted-imports */
import { Typography as MuiTypography, TypographyProps } from '@mui/material';

import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
  component?: React.ElementType;
  variant?: TypographyProps['variant'];
};

export const Typography = ({
  children,
  className,
  component,
  variant,
}: Props) => {
  return (
    <MuiTypography
      className={className}
      component={component || 'p'}
      variant={variant}
    >
      {children}
    </MuiTypography>
  );
};
